module.exports = __webpack_public_path__ + "e1e46cfddf1f9c867d0c58c5082a66ae.png";